// DataInstaDashboard.tsx
import { Box, Button, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../../styles/color";
import {
  ArrowRight,
  RightBackButton,
  Subscribers,
  ViewsIcon,
  VideoUploadIcon,
  PostIcon,
  ArrowDown,
  BlurInstaIcon,
} from "../../assets/icons";
import NoInquiry from "../../assets/images/NoInquiry.png";
import NoDataFound from "../../components/common/NoDataFound";
import Image from "../../components/common/Image";
import userImage from "../../assets/images/p1.png";
import AudienceChart from "../charts/AudienceChart";
import BarChart from "../charts/BarChart";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardDetails } from "../../redux/features/dashboard/dashboardSlice";
import { setLoading } from "../../redux/features";
import { useNavigate } from "react-router-dom";
import EmptyInsta from "../dashboard/EmptyInsta";

const DataInstaDashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState<any>(null);
  const { profileData } = useSelector((state: any) => state?.profile);

  // Get the first Instagram account ID from profile data
  const firstInstaAccountId = profileData?.insta_accounts?.[0]?.id;

  // Check if Instagram accounts exist
  const hasInstaAccounts =
    profileData?.insta_accounts && profileData.insta_accounts.length > 0;

  // Fetch dashboard data when component mounts or when account ID changes
  useEffect(() => {
    const fetchDashboardData = async () => {
      if (firstInstaAccountId) {
        try {
          dispatch(setLoading(true));
          const response = await dispatch(
            fetchDashboardDetails({
              type: "instagram",
              channel_id: firstInstaAccountId,
            })
          );

          if (response.payload?.status) {
            setDashboardData(response.payload.data);
          }
        } catch (error) {
          console.error("Error fetching dashboard data:", error);
        } finally {
          dispatch(setLoading(false));
        }
      }
    };

    fetchDashboardData();
  }, [firstInstaAccountId, dispatch]);

  // Dynamic user data based on API response
  const userData = [
    {
      value: dashboardData?.followers_count || "0",
      titile: "Followers",
      logo: <Subscribers />,
      bgColor: "#45A5FF",
    },
    {
      value: dashboardData?.media_count || "0",
      titile: "Post",
      logo: <PostIcon />,
      bgColor: "#FFB257",
    },
  ];

  const inquiries = dashboardData?.inquirys || [];

  const handleSubmit = () => {
    // Navigate to Instagram account setup
    navigate("/dashboard/add-account");
  };

  // Show EmptyInsta component if no Instagram accounts exist
  if (!hasInstaAccounts) {
    return <EmptyInsta profileData={profileData} handleSubmit={handleSubmit} />;
  }

  return (
    <Box>
      <Box
        sx={{
          "& .MuiAppBar-root": { position: "sticky", top: 0 },
          "& .MuiPaper-root": { pr: "none" },
        }}
      >
        <Box >
          {/* Stats section */}
          <Box
            display={{ md: "flex", xs: "block" }}
            flexDirection={{ md: "row", xs: "column" }}
          ></Box>

          {/* Inquiry & Channels section */}
          <Box sx={{ width: "100%", display: { md: "flex", xs: "block" } }}>
            <Box
              width="100%"
              gap="16px"
              display={{ md: "flex", xs: "block" }}
              justifyContent={"space-between"}
              // mt="16px"
            >
              {/* Latest Inquiries */}
              <Box flex="0 0 calc(100% - 8px)">
                <Box sx={{ display: { sm: "flex", xs: "block" } }}>
                  {userData.map((item, index) => (
                    <Box
                      key={index}
                      flex={"25%"}
                      flexWrap="wrap"
                      mb={{ md: "0px", xs: "16px" }}
                      mr={{ md: "16px", sm: "16px" }}
                      display={"flex"}
                      sx={{
                        background: colors.dark[800],
                        p: "20px",
                        borderRadius: "12px",
                        "&:last-child": { mr: { md: "0px", xs: "0px" } },
                      }}
                    >
                      <Box
                        sx={{
                          background: item.bgColor,
                          borderRadius: "10px",
                          mr: "20px",
                          width: { lg: "56px", xs: "50px" },
                          height: { lg: "56px", xs: "50px" },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {item.logo}
                      </Box>
                      <Box>
                        <Typography
                          fontSize="18px"
                          lineHeight="27px"
                          fontWeight={600}
                          // pb={"8px"}
                        >
                          {item.value}
                        </Typography>
                        <Box component="h3" sx={{ margin: 0, fontSize: '14px', fontWeight: 500, color:"white" }}>
                          {item.titile}
                        </Box>
                      </Box>
                    </Box>
                  ))}
                </Box>

                {/* <Box
                  flex="0 0 calc(50% - 8px)"
                  sx={{ background: colors.dark[800] }}
                  borderRadius={"10px"}
                  mt="16px"
                >
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                      fontSize: { md: "18px", sm: "16px", xs: "16px" },

                      fontWeight: "bold",
                      color: "#fff",
                      paddingTop: "25px",
                      paddingLeft: "25px",
                    }}
                  >
                    Audience
                  </Typography>
                  {/* <AudienceChart /> */}
                {/* </Box> */}
              </Box>

              {/* Channels */}

              {/* <Box
                flex="0 0 calc(50% - 8px)"
                sx={{
                  background: colors.dark[800],
                  marginTop: { md: "0px", xs: "16px" },
                }}
                borderRadius={"10px"}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    paddingTop: "25px",
                    paddingLeft: "25px",
                    paddingRight: "25px",
                  }}
                >
                  <Typography
                    variant="body1"
                    color="initial"
                    sx={{
                      fontSize: { md: "18px", sm: "16px", xs: "16px" },
                      fontWeight: "bold",
                      color: "#fff",
                    }}
                  >
                    Followers
                  </Typography>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    border="1px solid"
                    borderColor="#D3D3D3" // equivalent to lightgray2
                    borderRadius="6px"
                  >
                    <Typography
                      sx={{
                        color: "#ffffff",
                        fontFamily: "Poppins",
                        fontSize: "14px",
                        fontWeight: 500,
                        textAlign: "center",
                        pl: "11px",
                        py: "11px",
                        lineHeight: "10px",
                      }}
                    >
                      2023
                    </Typography>
                    <Button
                      component="button"
                      sx={{
                        minWidth: "auto",
                        padding: 1,
                        all: "unset",
                        paddingRight: "12px",
                        "&:active": {
                          backgroundColor: "transparent",
                        },
                        "&:focus": {
                          backgroundColor: "transparent",
                        },
                      }}
                      disableRipple
                      endIcon={<ArrowDown />}
                    ></Button>
                  </Box>
                </Box>
                {/* <BarChart /> */}
              {/* </Box> */}
            </Box>
          </Box>

          <Box
            sx={{
              width: "100%",
              justifyContent: "space-between",
              display: { md: "flex", xs: "block" },
            }}
          >
            <Box
              sx={{ background: colors.dark[800], pb: "30px" }}
              mb={{ md: "0px", xs: "20px" }}
              borderRadius={"10px"}
              flex="0 0 calc(50% - 8px)"
              mr={{ md: "0", xs: "0px" }}
              mt={{ md: "16px", xs: "16px" }}
            >
              <Box p={"25px"}>
                <Typography
                 variant="h2"
                  fontSize={"18px"}
                  lineHeight="27px"
                  sx={{
                    fontSize: { md: "18px", sm: "16px", xs: "16px" },
                 
                      textAlign: 'start',
                   
                  }}
                >
                  Latest inquiry
                </Typography>
              </Box>

              {inquiries.length > 0 ? (
                inquiries.map((item: any, index: number) => (
                  <Box key={index}>
                    <Box
                      className="border-remove"
                      sx={{ cursor: "pointer" }}
                      m={"0px 25px"}
                      display="flex"
                      borderBottom={`1px solid ${colors.dark[100]}`}
                      alignItems="center"
                      justifyContent={"flex-start"}
                    >
                      <Box p={"15px 15px 15px 0px"}>
                        <img
                          src={item.sender_profile?.profile || userImage}
                          width={44}
                          height={44}
                          style={{ objectFit: "cover" }}
                          alt="Inquiry"
                        />
                      </Box>
                      <Box>
                        <Typography lineHeight={"24px"} mb={"5px"}>
                          {item.subject}
                        </Typography>
                        <Box display="flex">
                          <Typography color={colors.gray[300]}>
                            {item.date}
                          </Typography>
                          <Typography
                            p={"0px 10px"}
                            fontSize="30px"
                            color={colors.gray[300]}
                          >
                            ·
                          </Typography>
                          <Typography color={colors.gray[300]}>
                            {item.time}
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        display={"flex"}
                        justifyContent={"flex-end"}
                        flexGrow={1}
                      >
                        <ArrowRight />
                      </Box>
                    </Box>
                  </Box>
                ))
              ) : (
                <NoDataFound
                  sx={{
                    textAlign: "center",
                    margin: "auto",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                  svg={<Image src={NoInquiry} />}
                  text={"You have no inquiries yet"}
                />
              )}

              {inquiries.length > 0 && (
                <Box display={"flex"} justifyContent={"center"} p={"30px 0px"}>
                  <Button
                    variant="text"
                    endIcon={<RightBackButton />}
                    onClick={() => navigate("/dashboard/inquiry")}
                  >
                    View All Inquiries
                  </Button>
                </Box>
              )}
            </Box>

            <Box
              sx={{ background: colors.dark[800] }}
              borderRadius={"10px"}
              flex="0 0 calc(50% - 8px)"
              mt="16px"
            >
              <Box p={"25px"}>
                <Typography
                  variant="h2"
                  fontSize={"18px"}
                  lineHeight="27px"
                  sx={{ fontSize: { md: "18px", sm: "16px", xs: "16px" }, textAlign: 'start', }}
                  >
                  Instagram pages
                </Typography>
              </Box>
              {dashboardData?.channels && dashboardData.channels.length > 0 ? (
                <Box
                  p={"0px 25px 0px 25px"}
                  sx={{
                    display: "flex",
                    gap: { lg: "24px", md: "16px", xs: "20px" },
                  }}
                >
                  {dashboardData.channels.map((channel: any, index: number) => (
                    <Box
                      key={channel.id}
                      sx={{
                        background: colors.dark[600],
                        borderRadius: "10px",
                        textAlign: "center",
                        my: "auto",
                        display: "block",
                        p: "20px 0px",
                        mb: "20px",
                        maxWidth: "165px",
                        width: "100%",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/dashboard/social/instagram")}
                    >
                      <Box sx={{ mb: "12px" }}>
                        <img
                          src={channel.image || userImage}
                          height="70px"
                          width="70px"
                          style={{ borderRadius: "100px" }}
                          alt="channel"
                        />
                      </Box>
                      <Box sx={{ mb: "10px", whiteSpace: "pre-wrap" }}>
                        <Typography color={colors.gray[300]} variant="body2">
                          {channel.channel_name}
                        </Typography>
                      </Box>
                      <Box>
                        <Button variant="text">
                          <RightBackButton
                            onClick={() =>
                              navigate("/dashboard/social/instagram")
                            }
                          />
                        </Button>
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"
                  alignItems="center"
                  py="103px"
                >
                  <BlurInstaIcon />

                  <Typography
                    sx={{
                      color: "#D3D3D3", // lightgray
                      fontFamily: "Poppins",
                      fontSize: { md: "18px", sm: "16px", xs: "16px" },

                      fontWeight: 500,
                      paddingTop: "29px",
                    }}
                  >
                    No More Accounts Added
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export { DataInstaDashboard };
